__turbopack_context__.v({
  "areaHeader": "YourReferrals-module__YqPJnq__areaHeader",
  "areaHeaderContent": "YourReferrals-module__YqPJnq__areaHeaderContent",
  "beach": "YourReferrals-module__YqPJnq__beach",
  "bubbleEmpty": "YourReferrals-module__YqPJnq__bubbleEmpty",
  "content": "YourReferrals-module__YqPJnq__content",
  "contentStack": "YourReferrals-module__YqPJnq__contentStack",
  "friendIcon": "YourReferrals-module__YqPJnq__friendIcon",
  "friendIcon1": "YourReferrals-module__YqPJnq__friendIcon1",
  "friendIcon2": "YourReferrals-module__YqPJnq__friendIcon2",
  "friendIcon3": "YourReferrals-module__YqPJnq__friendIcon3",
  "marginLeftAuto": "YourReferrals-module__YqPJnq__marginLeftAuto",
  "playerStatus": "YourReferrals-module__YqPJnq__playerStatus",
  "refereeListContainer": "YourReferrals-module__YqPJnq__refereeListContainer",
  "referralFooter": "YourReferrals-module__YqPJnq__referralFooter",
  "referralLink": "YourReferrals-module__YqPJnq__referralLink",
  "referralStat": "YourReferrals-module__YqPJnq__referralStat",
  "referralStatHeader": "YourReferrals-module__YqPJnq__referralStatHeader",
  "referralStatIcon": "YourReferrals-module__YqPJnq__referralStatIcon",
  "referralStatSection": "YourReferrals-module__YqPJnq__referralStatSection",
  "referredBy": "YourReferrals-module__YqPJnq__referredBy",
  "referredByAvatar": "YourReferrals-module__YqPJnq__referredByAvatar",
  "referrerBySpeechBubble": "YourReferrals-module__YqPJnq__referrerBySpeechBubble",
  "speechBubbleIcon": "YourReferrals-module__YqPJnq__speechBubbleIcon",
  "speechBubbleIcon1": "YourReferrals-module__YqPJnq__speechBubbleIcon1",
  "speechBubbleIcon2": "YourReferrals-module__YqPJnq__speechBubbleIcon2",
  "speechBubbleIcon3": "YourReferrals-module__YqPJnq__speechBubbleIcon3",
  "statValue": "YourReferrals-module__YqPJnq__statValue",
});
